<template>
  <el-container style="height: 100vh;">
    <el-header>
      <el-row>
        <el-col :span="4">
          <router-link tag="a" to="/panel" class="headerlogo">
          </router-link>
        </el-col>
        <el-col :span="16">
          <el-menu mode="horizontal"
                   :collapse-transition="false"
                   :router="true"
                   active-text-color="#0168fa">
            <el-menu-item index="/panel">
              <span slot="title">Panel</span>
            </el-menu-item>


            <el-submenu index="1">
              <template slot="title">Bina İşlemleri</template>
              <el-menu-item index="/bina">
                <span slot="title">Bina İşlemleri</span>
              </el-menu-item>
              <el-menu-item index="/bakim">
                <span slot="title">Bakım İşlemleri</span>
              </el-menu-item>
              <el-menu-item index="/bolge">
                <span slot="title">Bölge İşlemleri</span>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="2">
              <template slot="title">Personel İşlemleri</template>
              <el-menu-item index="/personel">
                <span slot="title">Personel İşlemleri</span>
              </el-menu-item>
              <el-menu-item index="/ekip">
                <span slot="title">Ekip İşlemleri</span>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="3">
              <template slot="title">Muhasebe İşlemleri</template>
              <el-menu-item index="/cari">
                <span slot="title">Cari İşlemleri</span>
              </el-menu-item>
              <el-menu-item index="/urun">
                <span slot="title">Ürün İşlemleri</span>
              </el-menu-item>
              <el-menu-item index="/fatura">
                <span slot="title">Fatura İşlemleri</span>
              </el-menu-item>
              <el-menu-item index="/stok">
                <span slot="title">Stok Durum</span>
              </el-menu-item>
            </el-submenu>


          </el-menu>
        </el-col>
        <el-col :span="4">
          <div class="aksiyon">
            <!--a href="#" class="projesecim">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-tool">
                <path
                    d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
              </svg>
              <span>Bakım Yap</span>
            </a-->
            <router-link tag="a" to="/qr" class="projesecim">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-tool">
                <path
                    d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
              </svg>
              <span>Bakım Yap</span>
            </router-link>


            <router-link tag="a" to="/ayarlar" class="projesecim">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-pocket">
                <path d="M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"></path>
                <polyline points="8 10 12 14 16 10"></polyline>
              </svg>
              <span>Ayarlar</span>
            </router-link>
            <a href="#" class="projesecim" @click="CikisYap">
              <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none"
                   stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <span>{{ $store.state.Personel.adi }}</span>
            </a>
          </div>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <router-view @Menu="MenuOlustur($event)"></router-view>
    </el-main>
    <BakimModal :Durum="BakimModalDurum" @Durum="Kapat"></BakimModal>
  </el-container>

</template>

<script>
import BakimModal from "./bakim/bakim";

export default {
  components: {BakimModal},
  data() {
    return {
      lo: false,
      BakimModalDurum: false
    }
  },
  methods: {
    Kapat() {
      this.BakimModalDurum = false
    },
    CikisYap() {
      this.$confirm("Oturumu kapatmak istediğinize eminmisiniz?", "Oturum Kapatılacak", {
        confirmButtonText: "Onayla",
        cancelButtonText: "İptal",
        type: 'warning'
      }).then(() => {
        this.$store.dispatch("logout");
      }).catch(() => {
        this.$message.info("Oturum Kapatılmadı");
      });
    },

  },
  created() {


  }
};
</script>
<style>
.projesecim {
  position: relative;
}

.projesecim svg {
  z-index: 2;
  fill: #ffffff;
  position: relative;
}

.projesecim span {
  font-family: 'Gilroy', sans-serif;
  font-weight: 600;
  position: relative;
  font-size: 10px;
  z-index: 1;
  border-radius: 2px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/comp/Index.vue